import Search from './Search'
import {Accordion} from './Accordion'
import {CollapseButton} from './CollapseButton'
import {Footer} from './Footer'
import {Item} from './Item'
import {Root} from './Root'
import {Section} from './Section'
import {ShowMore} from './ShowMore'

export type SidebarProps = import('./Root').SidebarProps
export type SidebarSectionProps = import('./Section').SectionProps
export type SidebarItemProps = import('./Item').ItemProps
export type SidebarAccordionProps = import('./Accordion').AccordionProps
export type SidebarShowMoreProps = import('./ShowMore').ShowMoreProps
export type SidebarCollapseButtonProps = import('./CollapseButton').CollapseButtonProps
export type SearchProps = import('./Search').SearchProps

export const Sidebar = Object.assign(Root, {
  Footer,
  Section,
  Item,
  Accordion,
  Search,
  ShowMore,
  CollapseButton,
})
